// @flow

import React from 'react'
import styled from 'styled-components'
import { fontSize } from 'frontend_core/dist/styles/variables'

const ReservationListHead = styled.div`
  &::after {
    clear: both;
    content: '';
    display: block;
  }
`
const ReservationListHeadTitle = styled.h1`
  font-size: ${fontSize.large}px;
  font-weight: bold;
`

export type PropTypes = {
  selectProps: Object,
  optionList: Array<{
    label: string,
    value: number,
  }>,
  children: any,
}

export default class ReservationListHeading extends React.Component<
  PropTypes,
  *,
> {
  props: PropTypes

  render() {
    return (
      <ReservationListHead>
        <ReservationListHeadTitle>
          {this.props.children}
        </ReservationListHeadTitle>
      </ReservationListHead>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationListHeading/index.jsx